import { UserManagerSettings } from "oidc-client-ts";

export const environment = {
    production: false,
    urlAddress: 'https://bapi.reghub.ca/api/v1',
    batchUrlAddress: 'https://batches.reghub.ca/api',
    consortiumUrlAddress: 'https://consortium.reghub.ca/api/v1'
  };

export const authConfig: UserManagerSettings = {
  authority: 'https://auth.reghub.ca',
  client_id: 'web.client',
  redirect_uri: 'https://admin.reghub.ca/callback',
  response_type: 'code',
  scope: 'openid profile offline_access RegHubAPI',
  post_logout_redirect_uri: 'https://admin.reghub.ca',
  loadUserInfo: true
};

export const idleTimers = {
    idleTimeoutInSeconds: 1500,
    logoutWarningCountdownInSeconds: 60
};